/* La'part V2: PDP behaviour. Vanilla, no deps. Reuses window.variantStrings (theme.liquid). */
(() => {
  const root = document.querySelector('.lp-pdp');
  if (!root) return;
  const strings = window.variantStrings || {};
  const S = { add: strings.addToCart || 'Add to cart', sold: strings.soldOut || 'Sold out', una: strings.unavailable || 'Unavailable' };
  let variants = [];
  try { variants = JSON.parse(root.querySelector('[data-lp-variants]')?.textContent || '[]'); } catch (_) { variants = []; }
  const idInput = root.querySelector('[data-lp-variant-id]');
  const radios = [...root.querySelectorAll('[data-lp-variant-radio]')];
  const addButtons = [...root.querySelectorAll('[data-lp-add-btn]')];
  const priceMain = root.querySelector('[data-lp-price-main]');
  const priceSticky = root.querySelector('[data-lp-price-sticky]');
  const priceStore = root.querySelector('[data-lp-price-store]');
  const gallery = root.querySelector('[data-lp-gallery]');
  const slides = [...root.querySelectorAll('[data-lp-slide]')];
  const thumbs = [...root.querySelectorAll('[data-lp-thumb]')];
  const dots = [...root.querySelectorAll('[data-lp-dot]')];
  const counter = root.querySelector('[data-lp-counter-current]');
  const availability = root.querySelector('[data-lp-availability]');
  const cloneInto = (target, source) => target && source && target.replaceChildren(...[...source.childNodes].map((n) => n.cloneNode(true)));
  const findVariant = (id) => variants.find((v) => String(v.id) === String(id));
  // Media tagged with data-lp-media-sku belongs to one color variant only (see
  // lp-main-product.liquid); untagged media is shared/generic and always shows.
  const updateGalleryForVariant = (sku) => {
    if (!sku) return;
    const toggle = (el) => {
      const owner = el.dataset.lpMediaSku;
      const hide = !!owner && owner !== sku;
      const target = el.closest('li') || el;
      target.hidden = hide;
    };
    slides.forEach(toggle);
    thumbs.forEach(toggle);
    dots.forEach(toggle);
    root.querySelectorAll('[data-lp-viewer-slide]').forEach(toggle);
    if (gallery) gallery.scrollLeft = 0;
    try { syncUi(0); } catch (_) { /* not initialised yet on first call */ }
    try { root.querySelector('[data-lp-viewer]')?.__lpSync?.(); } catch (_) { /* optional */ }
  };
  const applyVariant = (id, scrollGallery = true) => {
    const v = findVariant(id);
    if (!v) return;
    if (idInput) idInput.value = v.id;
    updateGalleryForVariant(v.sku);
    const tpl = priceStore?.querySelector(`[data-variant-price-tpl="${v.id}"]`);
    if (tpl) { cloneInto(priceMain, tpl); cloneInto(priceSticky, tpl); }
    const text = v.buyable ? S.add : v.available ? S.una : S.sold;
    addButtons.forEach((btn) => {
      btn.toggleAttribute('disabled', !v.buyable);
      btn.setAttribute('aria-disabled', String(!v.buyable));
      const span = btn.querySelector('[data-lp-add-btn-text]');
      if (span) span.textContent = text;
    });
    if (availability) { availability.hidden = v.buyable; availability.textContent = v.available ? S.una : S.sold; }
    if (scrollGallery && v.featured_media_id) {
      const feat = slides.find((s) => String(s.dataset.mediaId) === String(v.featured_media_id));
      if (feat && !feat.hidden) goTo(visSlides().indexOf(feat));
    }
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState(null, '', url);
    } catch (_) { /* non-critical */ }
  };
  radios.forEach((r) => r.addEventListener('change', () => applyVariant(r.value)));
  // ---- Gallery: swipe (touch), scroll/trackpad, mouse drag, arrows, keyboard. Only slides of the chosen variant count. ----
  const visible = (list) => list.filter((el) => !el.hidden && !el.closest('[hidden]'));
  const visSlides = () => visible(slides);
  const stageCounter = root.querySelector('.lp-pdp__counter--stage');
  let activeIdx = 0;
  const syncUi = (i) => {
    const vs = visSlides();
    activeIdx = Math.max(0, Math.min(vs.length - 1, i));
    const owner = vs[activeIdx];
    const all = slides.indexOf(owner);
    dots.forEach((d, di) => d.classList.toggle('is-active', di === all));
    thumbs.forEach((th, ti) => th.classList.toggle('is-active', ti === all));
    if (counter) counter.textContent = String(activeIdx + 1);
    const total = root.querySelector('[data-lp-counter-total]');
    if (total) total.textContent = String(vs.length);
    if (stageCounter) stageCounter.hidden = vs.length < 2;
    root.querySelectorAll('[data-lp-arrow]').forEach((a) => { a.hidden = vs.length < 2; });
  };
  const goTo = (i, smooth = true) => {
    const vs = visSlides();
    const target = vs[Math.max(0, Math.min(vs.length - 1, i))];
    if (target && gallery) gallery.scrollTo({ left: target.offsetLeft - gallery.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
  };
  const nearest = () => {
    const vs = visSlides();
    const x = gallery.scrollLeft + gallery.clientWidth / 2;
    let best = 0;
    vs.forEach((s, i) => { if (Math.abs(s.offsetLeft - gallery.offsetLeft + s.offsetWidth / 2 - x) < Math.abs(vs[best].offsetLeft - gallery.offsetLeft + vs[best].offsetWidth / 2 - x)) best = i; });
    return best;
  };
  if (gallery && slides.length > 1) {
    let raf = 0;
    gallery.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => syncUi(nearest())); }, { passive: true });
    root.querySelectorAll('[data-lp-arrow]').forEach((a) => a.addEventListener('click', () => goTo(nearest() + Number(a.dataset.lpArrow))));
    gallery.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(nearest() - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(nearest() + 1); }
    });
    // mouse drag-to-swipe (touch and trackpad already scroll natively)
    let drag = null;
    gallery.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      drag = { x: e.clientX, left: gallery.scrollLeft, moved: false };
    });
    window.addEventListener('pointermove', (e) => {
      if (!drag) return;
      const dx = e.clientX - drag.x;
      if (!drag.moved && Math.abs(dx) > 6) { drag.moved = true; gallery.classList.add('is-dragging'); }
      if (drag.moved) gallery.scrollLeft = drag.left - dx;
    });
    window.addEventListener('pointerup', (e) => {
      if (!drag) return;
      const d = drag; drag = null;
      gallery.classList.remove('is-dragging');
      if (d.moved) {
        const dx = e.clientX - d.x;
        const base = nearest();
        goTo(Math.abs(dx) > 40 ? (dx < 0 ? Math.max(base, activeIdx + 1) : Math.min(base, activeIdx - 1)) : base);
        gallery.dataset.lpJustDragged = '1';
        setTimeout(() => { delete gallery.dataset.lpJustDragged; }, 60);
      }
    });
    gallery.addEventListener('dragstart', (e) => e.preventDefault());
  }
  thumbs.forEach((th, i) => th.addEventListener('click', () => goTo(visSlides().indexOf(slides[i]))));
  dots.forEach((d, i) => d.addEventListener('click', () => goTo(visSlides().indexOf(slides[i]))));
  syncUi(0);

  // ---- Fullscreen viewer: same swipe / drag / arrows / keys, plus a counter ----
  const viewer = root.querySelector('[data-lp-viewer]');
  if (viewer) {
    const track = viewer.querySelector('[data-lp-viewer-track]');
    const vSlides = [...viewer.querySelectorAll('[data-lp-viewer-slide]')];
    const vVisible = () => vSlides.filter((s) => !s.hidden);
    const vCur = viewer.querySelector('[data-lp-viewer-current]');
    const vTot = viewer.querySelector('[data-lp-viewer-total]');
    const vNearest = () => {
      const vs = vVisible();
      const x = track.scrollLeft + track.clientWidth / 2;
      let best = 0;
      vs.forEach((s, i) => { if (Math.abs(s.offsetLeft + s.offsetWidth / 2 - x) < Math.abs(vs[best].offsetLeft + vs[best].offsetWidth / 2 - x)) best = i; });
      return best;
    };
    const vGo = (i, smooth = true) => {
      const vs = vVisible();
      const s = vs[Math.max(0, Math.min(vs.length - 1, i))];
      if (s) track.scrollTo({ left: s.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
    };
    const vSync = () => { if (vCur) vCur.textContent = String(vNearest() + 1); if (vTot) vTot.textContent = String(vVisible().length); };
    let opener = null;
    const openAt = (slideEl) => {
      opener = document.activeElement;
      viewer.showModal();
      vSync();
      vGo(visSlides().indexOf(slideEl), false);
      vSync();
    };
    slides.forEach((s) => s.addEventListener('click', () => { if (gallery?.dataset.lpJustDragged) return; openAt(s); }));
    viewer.addEventListener('close', () => opener?.focus());
    viewer.addEventListener('click', (e) => { if (e.target === viewer) viewer.close(); });
    viewer.querySelector('[data-lp-viewer-close]')?.addEventListener('click', () => viewer.close());
    viewer.querySelector('[data-lp-viewer-prev]')?.addEventListener('click', () => vGo(vNearest() - 1));
    viewer.querySelector('[data-lp-viewer-next]')?.addEventListener('click', () => vGo(vNearest() + 1));
    viewer.addEventListener('keydown', (e) => { if (e.key === 'ArrowLeft') vGo(vNearest() - 1); if (e.key === 'ArrowRight') vGo(vNearest() + 1); });
    let raf2 = 0;
    track.addEventListener('scroll', () => { cancelAnimationFrame(raf2); raf2 = requestAnimationFrame(vSync); }, { passive: true });
    let vdrag = null;
    track.addEventListener('pointerdown', (e) => { if (e.pointerType === 'mouse' && e.button === 0) vdrag = { x: e.clientX, left: track.scrollLeft, moved: false }; });
    window.addEventListener('pointermove', (e) => {
      if (!vdrag) return;
      const dx = e.clientX - vdrag.x;
      if (!vdrag.moved && Math.abs(dx) > 6) { vdrag.moved = true; track.classList.add('is-dragging'); }
      if (vdrag.moved) track.scrollLeft = vdrag.left - dx;
    });
    window.addEventListener('pointerup', (e) => {
      if (!vdrag) return;
      const d = vdrag; vdrag = null;
      track.classList.remove('is-dragging');
      if (d.moved) { const dx = e.clientX - d.x; const base = vNearest(); vGo(Math.abs(dx) > 40 ? base + (dx < 0 ? 1 : -1) : base); }
    });
    track.addEventListener('dragstart', (e) => e.preventDefault());
    viewer.__lpSync = vSync;
  }

  const qtyInput = root.querySelector('[data-lp-qty-input]');
  const lpCap = () => {
    if (!qtyInput) return;
    const max = Number(qtyInput.max) || Infinity;
    if ((parseInt(qtyInput.value, 10) || 1) > max) qtyInput.value = max;
  };
  root.querySelectorAll('[data-lp-variant-radio]').forEach((r) => r.addEventListener('change', () => {
    const v = variants.find((x) => String(x.id) === String(r.value));
    if (qtyInput && v) { if (v.max) qtyInput.max = v.max; else qtyInput.removeAttribute('max'); lpCap(); }
  }));
  if (qtyInput) qtyInput.addEventListener('change', lpCap);
  root.querySelectorAll('[data-lp-qty-step]').forEach((btn) => btn.addEventListener('click', () => {
    if (!qtyInput) return;
    const min = Number(qtyInput.min) || 1;
    qtyInput.value = Math.min(Number(qtyInput.max) || Infinity, Math.max(min, (parseInt(qtyInput.value, 10) || min) + Number(btn.dataset.lpQtyStep)));
  }));
  const stickyBar = root.querySelector('[data-lp-sticky-bar]');
  const sentinel = root.querySelector('[data-lp-atc-sentinel]');
  if (stickyBar && sentinel && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => stickyBar.classList.toggle('is-visible', !entry.isIntersecting)).observe(sentinel);
  }
  const firstDetails = document.querySelector('[data-lp-first-accordion]');
  if (firstDetails && window.matchMedia('(min-width: 1024px)').matches) firstDetails.open = true;
  if (idInput?.value) applyVariant(idInput.value, false);
})();
